import { render, staticRenderFns } from "./DoctrineMiniPanel.vue?vue&type=template&id=276fe62d&"
import script from "./DoctrineMiniPanel.vue?vue&type=script&lang=js&"
export * from "./DoctrineMiniPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports